module.exports = __webpack_public_path__ + "static/img/2a8358c0b6dde8c37e2b0a7e513ac299.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv6.jpg
// module id = 3sm1
// module chunks = 1